import { useQuery } from '@tanstack/react-query';
import { RELATED_TRAVELERS_QUERY_KEY } from '@/app/(main)/clients/create/const/const';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { GetRelatedPassengersResponse } from '@/types/clientsApiTypes';

export type UseGetRelatedTravelersQueryOptions = {
  enabled?: boolean;
};

export const useGetRelatedTravelersQuery = (options?: UseGetRelatedTravelersQueryOptions) => {
  const [searchQuery] = useSearchQuery();
  const clientId = searchQuery.get(CLIENT_ID_QUERY_KEY);
  const { doFetch } = useFetch<void, GetRelatedPassengersResponse>();

  return useQuery({
    queryKey: [RELATED_TRAVELERS_QUERY_KEY, clientId],
    queryFn: () => doFetch(`/api/client-details/${clientId}/related-passengers`),
    enabled: !!clientId && (options?.enabled ?? true),
  });
};
